<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{ 
       items: [
         {
           title:"Глобальный поиск",
           form: [
           {
             type:'select',
             name: 'Тип сообщества',
             options: [{text:'По умолчанию',value:''},{text:'группы',value:'group'},{text:'страницы',value:'page'},{text:'события',value:'event'}],
             vModel: {name:'type',value:''},
             vkapi: true
           },

           {
             type:'select-country',
             name: 'Выберите страну',
             cityName: 'Введите название города',
             options: [{text:'Любая',value:''},{text:'Россия',value:'1'},{text:'Украина',value:'2'},{text:'Белорусь',value:'3'},{text:'Казахстан',value:'4'},{text:'Азербайджан',value:'5'}],
             vModel: {name:'country_id',value:''},
             vModelCitiesIds:{name:'city_id',value: [] },
             vkapi: true
           },



           {
             type:'select',
             name: 'Сортировка',
             options: [{text:'По умолчанию',value:'0'},{text:'по скорости роста',value:'1'},{text:' по дневной посещаемости',value:'2'},{text:'по отношению количества лайков',value:'3'},{text:' по отношению количества комментариев',value:'4'},{text:'по отношению количества записей в обсуждениях',value:'5'}],
             vModel: {name:'sort',value:'0'},
             vkapi: true
           },
           {
             type: 'checkbox',
             name: 'Только с товарами',
             vModel: {name:'market',value:0},
             vkapi: true
           },
           {
             type: 'input',
             name: 'Колличество с фразы',
             vModel: {name:'count',value:'1000'},
             vkapi: true
           },
           ],
         },

       ],
     },
    title:{
      first: 'Сообществ найдено: '
    },

    searchLoop:{
      active:true,
      placeholder:'Названия сообществ'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат поиска сообществ',
      activator: false,
      activatorName: 'Начать поиск'
    },


    network:{
      processName: 'groups_global_search',
      dataType: 'groups',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/searcher/groups_global_search.php'
    },





    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'groups',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
      }
     },
     progressСircular: true,
   }


       }
     }
   }
</script>


<style>

</style>
